export enum Status {
  DENIED = 'denied',
  UNREQUESTED = 'unrequested',
  REQUESTED = 'requested',
  AUTHORIZED = 'authorized',
}
